import React from "react";
import { Button } from "@mui/material";

interface PrintButtonProps {
  conteudo: string;
}

const PrintButtonRascunho: React.FC<PrintButtonProps> = ({ conteudo }) => {
  const handlePrint = () => {
    if (!conteudo) return;

    const printWindow = window.open("", "", "height=600,width=800");
    if (!printWindow) return;

    printWindow.document.write(`
      <html>
        <head>
          <title>Imprimir Documento</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              padding: 20px; 
              position: relative;
              overflow: hidden;
            }

            /* Estilo das marcas d'água */
            .watermark {
              position: absolute;
              font-size: 4em;
              color: rgba(0, 0, 0, 0.1);
              font-weight: bold;
              pointer-events: none;
              z-index: -1;
              transform: rotate(-30deg);
            }

            /* Definindo uma área de impressão para se ajustar ao conteúdo */
            .content {
              position: relative;
              z-index: 1;
            }
          </style>
        </head>
        <body>
          <!-- Adicionando várias marcas d'água -->
          <div class="watermark" style="top: 10%; left: 10%;">Rascunho</div>
          <div class="watermark" style="top: 30%; left: 25%;">Rascunho</div>
          <div class="watermark" style="top: 50%; left: 40%;">Rascunho</div>
          <div class="watermark" style="top: 70%; left: 55%;">Rascunho</div>
          <div class="watermark" style="top: 80%; left: 75%;">Rascunho</div>
          <div class="watermark" style="top: 20%; left: 60%;">Rascunho</div>
          <div class="watermark" style="top: 60%; left: 15%;">Rascunho</div>
          <div class="watermark" style="top: 40%; left: 80%;">Rascunho</div>

          <!-- Conteúdo original -->
          <div class="content">${conteudo}</div>
        </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <Button variant="outlined" color="primary" onClick={handlePrint}>
      Imprimir Web
    </Button>
  );
};

export default PrintButtonRascunho;
